import Toggle from 'components/UI/Toggle';
import { useState } from 'react';
import FemaFullDetail from './FemaFullDetail';
import FemaHistoryItem from './FemaHistoryItem';
import FemaMessageSummary from './FemaMessageSummary';

/**
 * Renders FEMA language variants, full CAP details, and message history.
 *
 * @param {{ alert: { message_id: string, femaInfo?: Array, femaThread?: object, [key: string]: unknown } }} props - FEMA alert data.
 * @returns {JSX.Element} FEMA-specific alert details.
 */
const FemaDetails = ({ alert }) => {
  const [showAllLanguages, setShowAllLanguages] = useState(false);
  const [expandedVersionId, setExpandedVersionId] = useState(null);

  const languageInfos = alert.femaInfo ?? [];
  const displayedInfos = showAllLanguages ? languageInfos : languageInfos.slice(0, 1);
  const orderedVersions = [...(alert.femaThread?.versions ?? [])].reverse();
  const defaultDetailVersion = orderedVersions[0];
  const defaultDetailInfo = defaultDetailVersion?.payload?.info?.[0];
  const detailInfos = displayedInfos.length
    ? displayedInfos
    : defaultDetailInfo
      ? [defaultDetailInfo]
      : [];

  return (
    <div className="pe-3">
      {languageInfos.length > 1 && (
        <Toggle
          id={`fema-languages-${alert.message_id}`}
          label="Show all languages"
          value={showAllLanguages}
          callback={setShowAllLanguages}
        />
      )}

      {detailInfos.length > 0 && defaultDetailVersion ? (
        <div className="d-flex flex-column gap-3 mt-2">
          {detailInfos.map((info, index) => (
            <FemaFullDetail
              key={`${info.language ?? 'unspecified'}-${index}`}
              info={info}
              version={defaultDetailVersion}
              className="border rounded p-3"
            />
          ))}
        </div>
      ) : !defaultDetailVersion || !defaultDetailInfo ? (
        <FemaMessageSummary alert={alert} />
      ) : null}

      {orderedVersions.length > 0 && (
        <section aria-label="FEMA alert history" className="border-top pt-3">
          <h3 className="fs-6 fw-bold">Alert history</h3>
          <div className="d-flex flex-column gap-3">
            {orderedVersions.map((version) => (
              <FemaHistoryItem
                key={version.id}
                version={version}
                isExpanded={expandedVersionId === version.id}
                setExpandedVersionId={setExpandedVersionId}
                alert={alert}
              />
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default FemaDetails;
